// ── P10: o cadastro não é idempotente ──────────────────────────────────────
// Dois cliques em "salvar" criam DUAS contas e dois documentos `users` para a
// mesma pessoa. Não é configuração: `allowDuplicateEmails` está DESABILITADO (a
// proteção está ligada). O que falha é a ATOMICIDADE — toda checagem de
// duplicidade aqui é "consulta, depois grava", e duas chamadas simultâneas
// passam ambas pela consulta antes de qualquer uma gravar.
//
// Vale para os três guardas que o código já tem, e nenhum deles fecha a corrida:
//   · a unicidade de e-mail do Firebase Auth (não é transacional);
//   · `UsersService.checkIfEmailExists` antes de criar;
//   · a `runTransaction` + `exists()` de `createWithID` — que só protege um uid
//     JÁ CONHECIDO. No fluxo do operador o uid vem vazio e cada chamada ganha um
//     uid novo, então essa transação nunca chega a disparar.
//
// Medido em 08/09/2026, entre e-mails com mais de um cadastro corrente e ao menos
// um criado a partir de 2025: 110 documentos criados POR OPERADOR contra 49
// autocriados. Exemplos com o mesmo operador criando dois cadastros do mesmo
// e-mail no mesmo dia. Ou seja, a causa raiz viva é a tela do operador —
// `AuthContext.signup` tem um único chamador (`SignupPage`) e a rota dele está
// comentada no AppRouter.
//
// A coalescência é por CHAVE de identidade normalizada (`cadastro:<e-mail>` ou
// `praticante:<cpf>`): a segunda chamada não cria nada, ela ESPERA a primeira e
// recebe o mesmo resultado. Quem cria conta + `users` usa o MESMO prefixo, para
// que os dois caminhos coalesçam entre si e não só cada um consigo mesmo. O mapa vive no MÓDULO, não no
// componente — um re-render do provider não pode zerá-lo no meio de um cadastro
// em voo, que é exatamente a janela do duplo clique.
//
// A chave é liberada no `finally`: se o cadastro falhar, a pessoa tem de poder
// tentar de novo. Coalescer o erro seria trocar conta duplicada por cadastro
// impossível.
//
// Cobre a aba. Dois dispositivos ao mesmo tempo continuam passando: para isso só
// uma blocking function `beforeCreate`, que o projeto ainda não tem
// (`blockingFunctions` vazio).
const cadastrosEmVoo = new Map();

export const coalescerCadastro = (chaveBruta, executar) => {
  const chave = (chaveBruta || "").trim().toLowerCase();
  // Chave vazia não agrupa nada: sem identidade não há como saber se são a mesma
  // pessoa, e coalescer por engano fundiria dois cadastros diferentes.
  if (!chave || /:\s*$/.test(chave)) return executar();

  const emVoo = cadastrosEmVoo.get(chave);
  if (emVoo) {
    console.warn(
      `[CADASTRO] ${chave} já em andamento — segunda chamada reaproveitada, nenhum cadastro novo criado.`
    );
    return emVoo;
  }

  const promessa = Promise.resolve()
    .then(executar)
    .finally(() => cadastrosEmVoo.delete(chave));

  cadastrosEmVoo.set(chave, promessa);
  return promessa;
};

// Só para os testes: o mapa é estado de módulo e vaza entre casos.
export const __resetCadastrosEmVoo = () => cadastrosEmVoo.clear();

export default coalescerCadastro;
